import { Text } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

// To preserve new lines
export const FlowpageCaptionText = styled(Text)`
  white-space: pre-wrap;
`
